export function hasAdminAccess(user) {
  if (!user || typeof user !== "object") return false;

  if (user.is_superuser === true || user.is_staff === true) {
    return true;
  }

  const role = user.role_id ?? user.role;
  if (role && typeof role === "object") {
    return role.have_admin_access === true;
  }

  return false;
}
